import React from 'react';

import { FlexRow } from '@editor/components/utilities/layouts';
import { H5 } from '@repo/ui/components/Typography';

import { RadioDot } from '../utilities/RadioDot/styles';

import { VariationWrapper } from './styles';
import { VariationProps } from './types';

const Variation: React.FC<React.PropsWithChildren<VariationProps>> = ({
  isActive,
  label,
  onClick,
  children,
}) => {
  return (
    <VariationWrapper isActive={isActive} onClick={onClick}>
      <FlexRow alignItems="center" gap="6px">
        <RadioDot isActive={isActive} />
        <H5>{label}</H5>
      </FlexRow>
      {children}
    </VariationWrapper>
  );
};

export default Variation;
